import React, { Component } from 'react';

import { Container } from './styles.js';

import ModalCategorias from './modalCategorias';
import ModalProdutos from './modalProdutos';


import BannerDesktop from '../../../assets/banner_promo/combos/desktop/combos@3x.png';
import BannerMobile from '../../../assets/banner_promo/combos/mobile/combos@3x.png';
import PromosBanner from '../../../assets/campanhas/promote/promos/promos@3x.png';
import prodNoImg from '../../../assets/produtos/produto_sem-imagem.svg'

import Burguer from '../../../assets/emojis/combo/combo@3x.png';
import Paper from '../../../assets/emojis/papel/papel@3x.png';
import Carrinho from '../../../assets/emojis/carrinho/carrinho@3x.png';

import { IoMdClose } from 'react-icons/io';
import { FiChevronDown, FiTrash2 } from 'react-icons/fi';
import CurrencyInput from 'react-currency-input';
import DatePicker from "react-datepicker";
import ptBR from 'date-fns/locale/pt-BR';
import "react-datepicker/dist/react-datepicker.css"
import { format } from 'date-fns';
import api from '../../../services/api';
import moment from 'moment';
import Modal from 'react-modal';
import styled from 'styled-components';

export default class modalPromocoesProdutos extends Component {

    constructor(props) {
        super(props);
        this.state = {

            app: [
                {
                    nome: 'segunda',
                    id: 1
                },
                {
                    nome: 'terca',
                    id: 2
                },
                {
                    nome: 'quarta',
                    id: 3
                },
                {
                    nome: 'quinta',
                    id: 4
                },
                {
                    nome: 'sexta',
                    id: 5
                },
                {
                    nome: 'sabado',
                    id: 6
                },
                {
                    nome: 'domingo',
                    id: 7
                }
            ],
            token: props.token,
            loaded: false,
            windowWidth: window.innerWidth,
            combos: [],
            categorias: [],
            produtos: [],
            // isSelecting: true,
            isSelecting: false,
            categoriaClass: 'div-input',
            produtoClass: 'div-input',
            categoria: '',
            produto: '',
            categoriaId: null,
            produtoId: null,
            modalCategorias: false,
            modalProdutos: false,
            valorClass1: 'div-input-disabled',
            valorClass2: 'div-input',
            valor: '',
            valorPromocao: '0.00',
            permission: null,
            superUser: false,
            saved: false,
            salvar_produto: false,
            selectedInitialDate: null,
            selectedFinalDate: null,
            descricao: '',
            quantidade_pessoas: '',
            ordem: '',
            ativo: false,
            diasSelecionados: [],
            produtoPromo: {valor: 0},
            produtos_categorias: [],
            selectedCategoria: {},

            isStartDatePickerOpen: false,
            isEndDatePickerOpen: false,
            a_partir_de: null,
        }
    }


    toggleStartDatePicker = () => {
        this.setState(prevState => ({
          isStartDatePickerOpen: !prevState.isStartDatePickerOpen,
        }));
      };
    
      toggleEndDatePicker = () => {
        this.setState(prevState => ({
          isEndDatePickerOpen: !prevState.isEndDatePickerOpen,
        }));
      };
    
      handleInitialDateChange = date => {
        this.setState({
          selectedInitialDate: date,
          isStartDatePickerOpen: false,
        });
      };
    
      handleFinalDateChange = date => {
        this.setState({
          selectedFinalDate: date,
          isEndDatePickerOpen: false,
        });
      };


    async getCategorias() {
        const response = await api.get('api/categorias/listar', {
            headers: {
                Authorization: `Bearer ${this.state.token}`
            }
        }).then(res => {
            console.log(res.data, 'categorias/listar')

            this.setState({
                categorias: res.data,
            });
            // this.setState({ categorias: arrayProduto, loaded: true });

        }).catch(async e => {
            console.log(e)
        })
    }

    async getProdutos() {
        const response = await api.get('api/promocoes/listar', {
            headers: {
                Authorization: `Bearer ${this.state.token}`
            }
        }).then(res => {
            console.log(res.data, 'promocoes/listar');

            this.setState({ produtos: res.data, loaded: true });

        }).catch(async e => {
            console.log(e)
        })
    }

    async getPromos(id) {
        const response = await api.get(`api/produtos_da_categoria/listar/${id}`, {
            headers: {
                Authorization: `Bearer ${this.state.token}`
            }
        }).then(res => {
            this.setState({ produtos_categorias: res.data });
            this.setState({ selectedCategoria: this.state.categorias.find(categoria => categoria.id === id) })

        }).catch(async e => {
            console.log(e)
        })
    }

    async salvarPromocao() {
        //this.state.valor -> preço atual do produto
        //this.state.produtoPromo.valor -> valor do desconto

        if (Number(this.state.produtoPromo.valor) > Number(this.state.valor)){
            this.props.customError('valor do desconto não deve ser maior que preço atual do produto')
            document.getElementById('desconto').scrollIntoView({behavior: 'smooth', block: 'center', inline: 'center'})

        } else if (this.state.selectedCategoria.nome == undefined){
            this.props.customError('Escolha uma categoria')
            document.getElementById('categoria').scrollIntoView({behavior: 'smooth', block: 'center', inline: 'center'})

        } else if (!this.state.produto){
            this.props.customError('Escolha um produto para promoção')
            document.getElementById('produto').scrollIntoView({behavior: 'smooth', block: 'center', inline: 'center'})
            
        } else if (this.state.produtoPromo.data_inicial == undefined){
            this.props.customError('Escolha uma data inicial para promoção')
            document.getElementById('data').scrollIntoView({behavior: 'smooth', block: 'center', inline: 'center'})

        } else if (this.state.produtoPromo.data_final == undefined){
            this.props.customError('Escolha uma data final para promoção')
            document.getElementById('data').scrollIntoView({behavior: 'smooth', block: 'center', inline: 'center'})

        } else if (this.state.diasSelecionados.length == 0){
            this.props.customError('Escolha quais dias da semana a promoção ficará ativa')
            document.getElementById('dia-semana').scrollIntoView({behavior: 'smooth', block: 'center', inline: 'center'})
            
        } else {
            const diasDaSemana = ['segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado', 'domingo'];
            const diasAtivos = diasDaSemana.filter(dia => this.state.produtoPromo[dia.toLowerCase()]);
            const diasAtivosObj = [{
                nome: diasAtivos,
            }];

            const diasSelecionados = diasAtivosObj.flatMap(dia => dia.nome.map(nome => ({ nome })));
            try {
                await api.put("api/produtos-promocao/atualizar", {
                    produto_id: this.state.produtoId,
                    valor: this.state.produtoPromo.valor,
                    data_inicial: this.state.selectedInitialDate ? this.state.selectedInitialDate : this.state.produtoPromo.data_inicial,
                    data_final: this.state.selectedFinalDate ? this.state.selectedFinalDate : this.state.produtoPromo.data_final,
                    diasSelecionados: this.state.diasSelecionados.length > 0 ? this.state.diasSelecionados : diasSelecionados,
                    reativar: this.state.produtoPromo.reativar == true ? true : false,
                }, {
                    headers: {
                        Authorization: `Bearer ${this.state.token}`
                    }
                })

                // Reset the state to clear the fields
            this.setState({
                produto: '',
                produtoId: null,
                valor: '',
                produtoPromo: { valor: 0 },
                selectedCategoria: {},
                selectedInitialDate: null,
                selectedFinalDate: null,
                descricao: '',
                quantidade_pessoas: '',
                ordem: '',
                ativo: false,
                diasSelecionados: [],
                a_partir_de: null,
                saved: false,
            });

            this.setState({
                produto: '',
                produtoId: null,
                valor: '',
                produtoPromo: { valor: 0 },
                selectedCategoria: {},
                selectedInitialDate: null,
                selectedFinalDate: null,
                descricao: '',
                quantidade_pessoas: '',
                ordem: '',
                ativo: false,
                diasSelecionados: [],
                a_partir_de: null,
                saved: false,
            });

            // Trigger success callback and update the list of products
            this.props.success();
            this.getProdutos();

            // Close the selection modal
            this.setState({
                isSelecting: false,
            });

        } catch (e) {
            // Handle errors
            console.log(e.response);
            if (e.response && e.response.status === 400) {
                this.props.customError(e.response.data.error);
            } else {
                this.props.error();
            }
        }
    }
}
    //                 .then(res => {
    //                     this.props.success();
    //                     this.getProdutos()
    //                     this.setState({
    //                         isSelecting: false,
    //                     })
    //                 })
    //                 .catch(e => {
    //                     console.log(e.response);
    //                     if (e.response.status === 400) {
    //                         this.props.customError(e.response.data.error);
    //                     } else {
    //                         this.props.error();
    //                     }
    //                 })
    //         } catch (e) {
    //             console.log(e);
    //         }
    //     }
    // }

    createNovidade() {
        this.setState({
            isSelecting: true
        });
        this.getProdutos();
    }

    handleInputs(event) {
        switch (event.target.name) {
            case 'valor':
                var valor = event.target.value;
                var formatValue = valor.split(' ');
                var formated = formatValue[1]?.replace(/,/g, '.');
                this.setState({
                    valor: Number(formated).toFixed(2)
                });
                break;

            case 'valorPromocao':
                var valorPromocao = event.target.value;
                var formatValue = valorPromocao.split(' ');
                var formated = formatValue[1]?.replace(/,/g, '.');
                const precoPromo = { ...this.state.produtoPromo }
                precoPromo.valor = formated
                this.setState({
                    produtoPromo: precoPromo
                });
                break;
            default:
                break;
        }
        this.setState({ saved: true })
    }

    componentDidMount() {
        this.getProdutos()
        this.getCategorias()
        window.addEventListener("resize", this.handleResize);
    }

    handleResize = (e) => {
        this.setState({ windowWidth: window.innerWidth });
    }

    controllerModalCateg() {
        const state = this.state.modalCategorias;
        this.setState({
            modalCategorias: !state
        })
    }

    controllerModalProd() {
        if(this.state.selectedCategoria.nome != undefined){
            const state = this.state.modalProdutos;
            this.setState({
                modalProdutos: !state
            })
        }
    }

    setCategoria(id) {
        this.getPromos(id)
        this.controllerModalCateg();
    }

    setProduto(id) {
        const array = this.state.produtos_categorias;
        for (let i = 0; i < array.length; i++) {
            if (array[i].id === id) {
                this.setState({
                    produtoId: array[i].id,
                    produto: array[i].nome,
                    valor: array[i].valor_minimo ? array[i].valor_minimo : array[i].valor,
                    a_partir_de: array[i].valor_minimo,
                    ordem: array[i].ordem,
                    salvar_produto: array[i].salvar_produto,
                    quantidade_pessoas: array[i].quantidade_pessoas,
                    ativo: array[i].ativo,
                    descricao: array[i].descricao
                })
            }
        }
        this.controllerModalProd();
    }

    toggleSalvarProduto(tipo) {
        switch (tipo) {
            case 0:
                const novoState1 = { ...this.state.produtoPromo };
                novoState1.reativar = false;
                this.setState({ produtoPromo: novoState1 });
                break;
            case 1:
                const novoState2 = { ...this.state.produtoPromo };
                novoState2.reativar = true;
                this.setState({ produtoPromo: novoState2 });
                break;
            default:
                break;
        }
    }

    handleInitialDateChange = date => {
        this.setState({
            selectedInitialDate: date,
            produtoPromo: {
                ...this.state.produtoPromo,
                data_inicial: date
            }
        });
    };

    handleFinalDateChange = date => {
        this.setState({
            selectedFinalDate: date,
            produtoPromo: {
                ...this.state.produtoPromo,
                data_final: date
            }
        });
    };

    handleCheckboxChange = (event) => {
        const item = this.state.app.find((item) => item.id === Number(event.target.id));
        const isChecked = event.target.checked;

        this.setState(prevState => {
            const diasSelecionados = [...prevState.diasSelecionados];
            const produtoPromo = { ...prevState.produtoPromo };

            const index = diasSelecionados.findIndex((d) => d.nome === item.nome);
            if (index === -1 && isChecked) {
                diasSelecionados.push(item);
            } else if (index !== -1 && !isChecked) {
                diasSelecionados.splice(index, 1);
            }

            diasSelecionados.forEach(d => {
                produtoPromo[d.nome.toLowerCase()] = true;
            });
            Object.keys(produtoPromo)
                .filter(key => ['segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado', 'domingo'].includes(key))
                .forEach(key => {
                    if (!diasSelecionados.some(d => d.nome.toLowerCase() === key)) {
                        produtoPromo[key] = false;
                    }
                });

            return { diasSelecionados, produtoPromo };
        });
    }

    delProdutos(id) {
        try {
            api.post(`api/produtos-promocao/deletar/${id}`,{}, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            })
                .then(res => {
                    // this.props.success();
                    this.getProdutos();
                })
                .catch(e => {
                    console.log(e);
                    this.props.error();
                })
        } catch (e) {
            console.log(e);
        }
    }

    render() {
        // conserta o dia da semana para ser mostrado no front
        const dayNames = {
            'segunda': 'Segunda-feira',
            'terca': 'Terça-feira',
            'quarta': 'Quarta-feira',
            'quinta': 'Quinta-feira',
            'sexta': 'Sexta-feira',
            'sabado': 'Sábado',
            'domingo': 'Domingo'
        };
        // formatador da data que vem da API
        // const initialDate = new Date(this.state.produtoPromo.data_inicial).toLocaleDateString('pt-BR');
        // const finalDate = new Date(this.state.produtoPromo.data_final).toLocaleDateString('pt-BR');
        const initialDate = new Date(this.state.produtoPromo.data_inicial);
        const finalDate = new Date(this.state.produtoPromo.data_final);

        const { selectedInitialDate, selectedFinalDate, isStartDatePickerOpen, isEndDatePickerOpen } = this.state;

        // mostra quais dias estão ativos no checkbox
        const { produtoPromo, app } = this.state;
        const diasDaSemana = ['segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado', 'domingo'];
        const diasAtivos = diasDaSemana.filter(dia => produtoPromo[dia.toLowerCase()]);

        //simula quanto ficará o preço do produto (valor produto - desconto)
        const valorPromo = this.state.valor - this.state.produtoPromo.valor || 0

        return (
            <Container>
                <Modal
                    isOpen={this.state.modalCategorias}
                    // onAfterOpen={this.controllerModalCateg(this.state.modalCategorias)}
                    // onRequestClose={() => this.controllerModalCateg(this.state.modalCategorias)}
                    // closeModal={() => this.controllerModalCateg(this.state.modalCategorias)}
                    onRequestClose={() => this.controllerModalCateg()}
                    closeModal={() => this.controllerModalCateg()}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    closeTimeoutMS={100}
                    style={this.state.windowWidth > 930 ? entrada : mobile}
                    contentLabel="Modal"
                >
                    <ModalCategorias
                        categorias={this.state.categorias}
                        selecionar={(id, nome) => this.setCategoria(id, nome)}
                        // closeModal={() => this.controllerModalCateg(this.state.modalCategorias)} />
                        closeModal={() => this.controllerModalCateg()} />

                </Modal>
                <Modal
                    isOpen={this.state.modalProdutos}
                    // onAfterOpen={this.controllerModal(this.state.isOpen)}
                    onRequestClose={() => this.controllerModalProd()}
                    closeModal={() => this.controllerModalProd()}
                    shouldCloseOnEsc={true}
                    shouldCloseOnOverlayClick={true}
                    closeTimeoutMS={100}
                    style={this.state.windowWidth > 930 ? entrada : mobile}
                    contentLabel="Modal"
                >
                    <ModalProdutos
                        produtos={this.state.produtos_categorias}
                        selecionar={(id, nome) => this.setProduto(id, nome)}
                        closeModal={() => this.controllerModalProd(this.state.modalProdutos)} />
                </Modal>


                <div className="header">
                    <img
                        className="banner"
                        src={PromosBanner}
                        alt="Banner Combos"
                    />
                    <button onClick={() => this.props.closeModal()}>
                        <IoMdClose className="icon" />
                    </button>

                    <div className="content">

                        <img src={Carrinho} alt="Combos" />

                        <h1>Cadastre seu
                            <p>produto</p>
                        </h1>

                        <h5><span>Aplique desconto</span> em seus produtos
                            <p>e <span>aumente suas vendas.</span></p></h5>
                    </div>
                </div>


                {this.state.loaded
                    && (this.state.isSelecting
                        ? (



                            <div className="configurar">
                                <img src={Paper} alt="" />

                                <h1>Vamos configurar sua <p>promoção de produtos</p></h1>
                                <div className="inputs">
                                    <div id="categoria" className={this.state.categoriaClass} onClick={() => this.controllerModalCateg()}>
                                        <input
                                            value={this.state.selectedCategoria.nome}
                                            name="valor"
                                            type="text"
                                            required
                                            style={{
                                                caretColor: 'transparent'
                                            }}
                                            onChange={() => { }}
                                        />
                                        <label htmlFor="" className="label-name">
                                            <span className="content-name">Categoria</span>
                                        </label>
                                        <button className="botao-olho">
                                            <FiChevronDown size={22} color="#1c0506" className="i" />
                                        </button>
                                    </div>

                                    {/* <div className={this.state.categoriaId === null ? 'div-input-disabled' : this.state.produtoClass} onClick={() => this.controllerModalProd()}> */}
                                    <div id="produto" className={this.state.selectedCategoria.nome === undefined ? 'div-input-disabled' : this.state.produtoClass} onClick={() => this.controllerModalProd()}>
                                        <input
                                            //disabled={this.state.categoriaId === null ? true : false}
                                            disabled={this.state.selectedCategoria.nome === undefined ? true : false}
                                            value={this.state.produto}
                                            name="valor"
                                            type="text"
                                            required
                                            contentEditable={false}
                                            style={{
                                                caretColor: 'transparent'
                                            }}
                                            onChange={(event) => {
                                                const selectedProduto = this.state.produto.find(produto => produto.nome === event.target.value);
                                            }}
                                        />
                                        <label htmlFor="" className="label-name">
                                            <span className="content-name">Produto</span>
                                        </label>
                                        <button className="botao-olho">
                                            <FiChevronDown size={22} color="#1c0506" className="i" />
                                        </button>
                                    </div>



                                    <div className={this.state.valorClass1}>
                                        <CurrencyInput
                                            inputType="text"
                                            maxLength="9"
                                            name="valor"
                                            prefix="R$ "
                                            onFocus={() => {
                                                this.setState({
                                                    valorClass1: 'div-input-focado'
                                                })
                                            }}
                                            onBlur={() => {
                                                this.setState({
                                                    valorClass1: 'div-input'
                                                })
                                            }}
                                            required
                                            disabled
                                            decimalSeparator=","
                                            value={this.state.valor}
                                            onChangeEvent={
                                                (e) => this.state.superUser ?
                                                    this.state.permission === 2 ? this.handleInputs(e) : null
                                                    :
                                                    this.handleInputs(e)
                                            }
                                        />

                                        <label htmlFor="" className="label-name">
                                            <span className="content-name">{this.state.a_partir_de ? 'A partir de' : 'Preço atual'}</span>
                                        </label>
                                    </div>
                                </div>

                                <div className='Textoh3'>
                                    <span>Desconto no preço do produto</span>
                                </div>

                                <span className='subtextoh3'>Digite o valor do desconto</span>

                                <div id="desconto" className={this.state.valorClass2}>
                                    <CurrencyInput
                                        inputType="text"
                                        maxLength="9"
                                        name="valorPromocao"
                                        prefix="R$ "
                                        onFocus={() => {
                                            this.setState({
                                                valorClass2: 'div-input-focado'
                                            })
                                        }}
                                        onBlur={() => {
                                            this.setState({
                                                valorClass2: 'div-input'
                                            })
                                        }}
                                        required
                                        decimalSeparator=","
                                        value={this.state.produtoPromo.valor ? this.state.produtoPromo.valor : ''}
                                        onChangeEvent={
                                            (e) => this.state.superUser ?
                                                this.state.permission === 2 ? this.handleInputs(e) : null
                                                :
                                                this.handleInputs(e)
                                        }
                                    />

                                    <label htmlFor="" className="label-name">
                                        <span className="content-name">Valor do desconto</span>
                                    </label>
                                </div>

                                <div className='Textoh3'>
                                    <span>Preço do produto na promoção</span>
                                </div>

                                <span className='subtextoh3'>Este é o preço que o seu produto será vendido</span>

                                <div className="div-input-disabled">
                                    {/* <CurrencyInput
                                        inputType="text"
                                        // maxLength="9"
                                        // name="valorPromocao"
                                        prefix="R$ "
                                        // required
                                        disabled
                                        decimalSeparator=","
                                        value={"R$-,-"}
                                    /> */}
                                    <input 
                                        disabled
                                        value={valorPromo < 0  ? 'R$--,--' : Number(valorPromo).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                    />

                                    <label htmlFor="" className="label-name">
                                        <span className="content-name">{this.state.a_partir_de ? 'A partir de' : 'Preço na promoção'}</span>
                                    </label>
                                </div>

                                <div className='Textoh3'>
                                    <span>Duração da promoção</span>
                                </div>
                                <span className='subtextoh3'>Escolha a quantidade de dias que sua promoção deverá ficar ativa</span>

                                {/* ******DATA****** */}

                                <div id="data" className="horarios">
                                    <div className="turno-fechado">
                                        <div className="left">
                                            <h5>Início</h5>
                                                {/* <div className="chevronDate" onClick={this.toggleStartDatePicker}>
                                                    <h4>Selecione</h4>
                                                    <FiChevronDown color={'#000000'} size={24} className="chevronDate2" />
                                                </div> */}
                                                {/* {isStartDatePickerOpen && ( */}
                                                    <CustomDatePicker
                                                        locale={ptBR}
                                                        value={initialDate ? initialDate : new Date()}
                                                        showTimeSelect={false}
                                                        placeholderText={"Selecione"}
                                                        dateFormat="dd/MM/yyyy"
                                                        selected={selectedInitialDate}
                                                        onChange={this.handleInitialDateChange}
                                                        customInput={<CustomInput />}
                                                    />
                                                {/* )} */}
                                        </div>
                                        {/* <FiChevronDown color={'#000000'} size={24} className="chevron" onClick={this.toggleStartDatePicker} /> */}
                                    </div>

                                    <div className="turno-fechado">
                                        <div className="left">
                                            <h5>Fim</h5>
                                                {/* <div className="chevronDate" onClick={this.toggleEndDatePicker}>
                                                    <h4>Selecione</h4>
                                                    <FiChevronDown color={'#000000'} size={24} className="chevronDate2" />
                                                </div> */}
                                                {/* {isEndDatePickerOpen && ( */}
                                                    <CustomDatePicker
                                                        locale={ptBR}
                                                        value={finalDate ? finalDate : new Date()}
                                                        showTimeSelect={false}
                                                        placeholderText="Selecione"
                                                        dateFormat="dd/MM/yyyy"
                                                        selected={selectedFinalDate}
                                                        onChange={this.handleFinalDateChange}
                                                        customInput={<CustomInput />}
                                                    />
                                                {/* )} */}
                                        </div>
                                        {/* <FiChevronDown color={'#000000'} size={24} className="chevron" onClick={this.toggleEndDatePicker} /> */}
                                    </div>
                                </div>

                                {/* <div className='horarios'>
                                    <div className="turno-fechado">
                                        <div className="left">
                                            <h5>Início</h5>

                                            <div className="chevronDate">
                                                <h4>Selecione</h4>
                                                <FiChevronDown color={'#000000'} size={24} className="chevronDate2" />
                                            </div>

                                            <CustomDatePicker
                                                locale={ptBR}
                                                value={initialDate ? initialDate : new Date()}
                                                selected={this.state.selectedInitialDate}
                                                onChange={this.handleInitialDateChange}
                                                showTimeSelect={false}
                                                placeholderText=""
                                                dateFormat="dd/MM/yyyy"
                                            />
                                        </div>
                                        <FiChevronDown color={'#000000'} size={24} className="chevron" />
                                    </div>

                                    <div className="turno-fechado">
                                        <div className="left">
                                            <h5>Fim</h5>

                                            <div className="chevronDate">
                                                <h4>Selecione</h4>
                                                <FiChevronDown color={'#000000'} size={24} className="chevronDate2" />
                                            </div>

                                            <CustomDatePicker
                                                locale={ptBR}
                                                value={finalDate ? finalDate : new Date()}
                                                selected={this.state.selectedFinalDate}
                                                onChange={this.handleFinalDateChange}
                                                showTimeSelect={false}
                                                placeholderText=""
                                                dateFormat="dd/MM/yyyy"
                                            />
                                        </div>
                                        <FiChevronDown color={'#000000'} size={24} className="chevron" />
                                    </div>
                                </div> */}

                                <div className='Textoh3'>
                                    <span>Disponibilidade durante a semana</span>
                                </div>
                                <span className='subtextoh3'>Selecione em quais dias da semana a promoção estará disponível</span>

                                {/* ******DIAS DA SEMANA******* */}
                                <div id="dia-semana" className="card">
                                    {this.state.app.map(item => {

                                        const isChecked = diasAtivos.includes(item.nome.toLowerCase());
                                        const index = this.state.diasSelecionados.findIndex((d) => d.nome === item.nome);

                                        const isCheckedSelected = index !== -1;
                                        const isDayActive = this.state.produtoPromo[item.nome.charAt(0).toUpperCase() + item.nome.slice(1)];

                                        return (
                                            <div className="cartao" key={item.id}>
                                                <label className="main">
                                                    <input
                                                        type="checkbox"
                                                        name={item.nome}
                                                        id={item.id}
                                                        checked={isChecked || isCheckedSelected}
                                                        disabled={isDayActive && !isChecked}
                                                        onChange={this.handleCheckboxChange}
                                                    />
                                                    <span className="check-app"></span>
                                                    <span className="img-app-disabled" />
                                                    <span className="label-app">{dayNames[item.nome]}</span>
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className='Textoh3'>
                                    <span>Ativar produto após o fim da promoção</span>
                                </div>
                                <span className='subtextoh3'>Deseja que seu produto fique ativo após o fim da promoção?</span>



                                <div className="options">
                                    <div onClick={
                                        () => this.state.superUser ?
                                            this.state.permission === 2 ? this.toggleSalvarProduto(0) : null
                                            : this.toggleSalvarProduto(0)
                                    }
                                        name="nao"
                                        className={!this.state.produtoPromo.reativar ? 'option-selected' : 'option'}>
                                        <span>Não</span>
                                    </div>
                                    <div onClick={
                                        () => this.state.superUser ?
                                            this.state.permission === 2 ? this.toggleSalvarProduto(1) : null
                                            : this.toggleSalvarProduto(1)
                                    }
                                        name="sim"
                                        className={this.state.produtoPromo.reativar ? 'option-selected' : 'option'}>
                                        <span>Sim</span>
                                    </div>
                                </div>

                                <button className="save" onClick={() => this.salvarPromocao()}>
                                    Salvar alterações
                                </button>
                            </div>

                        ) : (
                            <div className="destaques">
                                <h1>Promoções de produtos</h1>

                                {!!this.state.produtos.length
                                    ? (
                                        <h5>Você possui <span>0{this.state.produtos.length} {this.state.produtos.length < 2 ? "produto" : "produtos"} na promoção.</span></h5>
                                    )
                                    : (
                                        <h5>Você ainda não possui nenhuma promoção de produtos.</h5>
                                    )
                                }

                                <div className="produtos">

                                    {!!this.state.produtos.length
                                        && (this.state.produtos.map(item => (

                                            <div className="produto-filled">

                                                <div className="left">
                                                    <img
                                                        src={item.imagem ? `https://appedidos-share-private.s3.amazonaws.com/${item.imagem}` : prodNoImg}
                                                    // alt={item.produto.nome} 
                                                    />

                                                    <span className="name">{item.nome}</span>

                                                    <div className="middle-content">
                                                        <p>Nome</p>
                                                        <span>{item.nome}</span>

                                                        <p>Preço</p>
                                                        {item.valor_minimo ?
                                                            <>
                                                                <span>A partir de</span>
                                                                <div> 
                                                                    <span className='price-before'>R$ {item.valor_minimo.replace('.', ',')}</span> <span> <b> R$ {item.produtos_promo.valor.replace('.', ',')} </b></span>
                                                                </div>
                                                            </>
                                                            :
                                                            <>
                                                                <div> 
                                                                    <span className='price-before'>R$ {item.valor.replace('.', ',')}</span> <span> <b> R$ {item.produtos_promo.valor.replace('.', ',')} </b></span>
                                                                </div>
                                                            </>
                                                        }
                                                    
                                                        <p>Válido até</p>
                                                        <span className='font-weight'>{item.produtos_promo.data_final.replace(/^(\d{4})-(\d{2})-(\d{2}).*/, "$3/$2/$1")}</span>
                                                    </div>
                                                </div>


                                                {/* ARRUMAR A DATA QUE ESTÁ SENDO PUXADA  */}

                                                <div className="right">
                                                    {/* <span>De R$ 30.00 por <a>R$25.00</a> até <a>{moment(item.selectedFinalDate).format('L')}</a></span> */}
                                                    {item.valor_minimo ?
                                                        <span>
                                                            A partir de <span className='price-before'>R$ {item.valor_minimo.replace('.', ',')}</span>
                                                           <b> R$ {item.produtos_promo.valor.replace('.', ',')} </b>
                                                            até {item.produtos_promo.data_final.replace(/^(\d{4})-(\d{2})-(\d{2}).*/, "$3/$2/$1")}
                                                        </span>
                                                        :
                                                        <span>
                                                            De R$ {item.valor.replace('.', ',')} por <b>R$ {item.produtos_promo.valor.replace('.', ',')} </b> 
                                                            até <b>{item.produtos_promo.data_final.replace(/^(\d{4})-(\d{2})-(\d{2}).*/, "$3/$2/$1")}</b>
                                                        </span>
                                                    }

                                                    <button onClick={() => this.delProdutos(item.produtos_promo.id)}>
                                                        <FiTrash2 className="icon" />
                                                    </button>
                                                </div>
                                            </div>
                                        ))
                                        )
                                    }

                                    <button className="adicionar" onClick={() => this.createNovidade()}>
                                        Montar promoção de produtos
                                    </button>
                                </div>
                            </div>
                        )
                    )
                }
            </Container>
        )
    }

}

const CustomInput = React.forwardRef((props, ref) => {
    return (
        <div className='div-custom-datapicker'>
            <label className='txt-datepicker' onClick={props.onClick} ref={ref}>
                {props.value || props.placeholder}
            </label>
            <FiChevronDown color={'#000000'} size={24} className="chevron-datepicker" onClick={props.onClick}/>
        </div>
    );
  });

const entrada = {
    overlay: {
        position: 'fixed',
        zIndex: 21,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.03)',
    },
    content: {
        borderWidth: '0px',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '322px',
        height: '100%',
        maxHeight: '256px'
    }
};

const mobile = {
    overlay: {
        position: 'fixed',
        zIndex: 21,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
    },
    content: {
        borderWidth: '0px',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -42%)',
        width: '100%',
        maxWidth: '360px',
        height: '85%',
    }
};

const CustomCalendar = styled.div`
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
  width: auto;
  background-color: transparent;
  border: none;
  box-shadow: none;
`;

const CustomMonthContainer = styled.div`
  font-size: 1rem;
  background-color: transparent;
  border: none;
  box-shadow: none;
`;

const CustomHeader = styled.div`
  font-weight: bold;
  background-color: transparent;
  border: none;
  box-shadow: none;
`;

const CustomDatePicker = styled(DatePicker)`
  position: static;
  display: inline-block;
  font-size: inherit;
  font-family: Montserrat;
  color: inherit;
  background-color: transparent;
  border: none;
  box-shadow: none;

  .react-datepicker__month-container {
    ${CustomMonthContainer};
  }

  .react-datepicker__header {
    ${CustomHeader};
  }

  .react-datepicker__calendar-container {
    ${CustomCalendar};
  }
`;